import { render } from "./CompanyForm.vue?vue&type=template&id=41a06b0f&scoped=true"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"

import "./CompanyForm.vue?vue&type=style&index=0&id=41a06b0f&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a06b0f"]])

export default __exports__